/**
 * Official Instagram profile — use for every external Instagram `<a href>`.
 * Do not use React Router `<Link>` for this URL.
 */
export const OFFICIAL_INSTAGRAM_PROFILE_URL = 'https://www.instagram.com/workshopsbyaabha/';
